// Packages
import React, { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button,
  Card,
} from "reactstrap";
import axios from "axios";
// Utils
import { catchHandler, getRequestHeaders } from "../utils";
// Styling
import "./AddCourse.css";

const AddCourse = React.memo((props) => {
  const rootPathname = useMemo(() => "/courses", []);
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState({
    name: "",
    description: "",
    deactivatedForSubventionat: false,
    deactivatedForEnrollment: false,
  });
  const [errors, setErrors] = useState({});
  const history = useHistory();

  const onSubmit = useCallback(
    (event) => {
      event.preventDefault();

      setLoading(true);
      setErrors({});

      axios
        .post("/api/courses/create-course", fields, getRequestHeaders())
        .then((res) => {
          const { data = {} } = res;
          const { name = "" } = data;
          toast.success(`Cursul [${name}] a fost adaugat cu succes`);
          history.push(rootPathname);
        })
        .catch((err) => {
          const { name = "", description = "" } = catchHandler(history, err);
          setErrors({ name, description });
          setLoading(false);
        });
    },
    [history, fields, rootPathname]
  );

  const onCancel = useCallback(
    (event) => {
      event.preventDefault();
      history.push(rootPathname);
    },
    [history, rootPathname]
  );

  const onInputChange = useCallback((event) => {
    const { target = {} } = event;
    const { name, value } = target;
    setFields((prevFields) => ({ ...prevFields, [name]: value }));
  }, []);

  const onCheckboxChange = useCallback((event) => {
    const { target = {} } = event;
    const { name, checked } = target;
    setFields((prevFields) => ({ ...prevFields, [name]: checked }));
  }, []);

  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col sm="12" md={{ size: 10, offset: 1 }}>
          <Card className="p-5 bg-light shadow-sm">
            <h2 className="mb-5 mx-auto text-center">Adaugare Curs</h2>
            <Form>
              <FormGroup>
                <Label for="name">Denumire</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  invalid={Boolean(errors["name"])}
                  value={fields["name"]}
                  onChange={onInputChange}
                />
                <FormFeedback>{errors["name"]}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label for="description">Descriere</Label>
                <Input
                  id="description"
                  name="description"
                  type="textarea"
                  invalid={Boolean(errors["description"])}
                  value={fields["description"]}
                  onChange={onInputChange}
                />
                <FormFeedback>{errors["description"]}</FormFeedback>
              </FormGroup>
              <FormGroup check className="mt-3">
                <Input
                  id="deactivatedForSubventionat"
                  name="deactivatedForSubventionat"
                  type="checkbox"
                  checked={fields["deactivatedForSubventionat"]}
                  onChange={onCheckboxChange}
                />
                <Label check for="deactivatedForSubventionat">
                  Dezactivat pentru contractele subventionate
                </Label>
              </FormGroup>
              <FormGroup check className="mt-3">
                <Input
                  id="deactivatedForEnrollment"
                  name="deactivatedForEnrollment"
                  type="checkbox"
                  checked={fields["deactivatedForEnrollment"]}
                  onChange={onCheckboxChange}
                />
                <Label check for="deactivatedForEnrollment">
                  Dezactivat pentru inrolare
                </Label>
              </FormGroup>
              <FormGroup className="d-flex justify-content-between mt-5">
                <Button
                  type="submit"
                  color="primary"
                  onClick={onSubmit}
                  disabled={loading}
                >
                  Salvare
                </Button>
                <Button outline color="secondary" onClick={onCancel}>
                  Renuntare
                </Button>
              </FormGroup>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
});

export default AddCourse;
